export default "/institutions/neon.svg";